import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const richHeader = style([
  {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: space.s10,
  },
  responsiveStyle({
    mobile: {
      paddingBottom: space.s16,
      gap: space.s16,
    },
    tablet: {
      padding: space.s32,
      gap: space.s32,
    },
  }),
]);

export const infoContainer = style([
  responsiveStyle({
    mobile: {
      width: '100%',
    },
  }),
]);

export const topLineContainer = style([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s4,
  },
]);

export const titleContainer = style([
  {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%',
  },
  responsiveStyle({
    tablet: {
      justifyContent: 'space-between',
    },
  }),
]);

export const richHeaderTitle = style([
  {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  responsiveStyle({
    mobile: {
      padding: `${space.s10}px 0`,
      ...typography.titleLg,
      marginBottom: 0,
    },
    tablet: {
      padding: 0,
      ...typography.headlineLg,
      marginBottom: space.s6,
    },
  }),
]);

export const richHeaderDescription = style([
  {
    color: themeVars.container.foreground.secondary,
  },
  responsiveStyle({
    mobile: {
      ...typography.bodySm,
    },
    tablet: {
      ...typography.bodyLg,
    },
  }),
]);
